import { APP_STUDIES, STUDY_TYPE_ABBREVIATIONS } from "../_constants";

const validateFormData = async (data) => {
    let isValid = true;
    let validatedData = data
    return new Promise((resolve) => {
        for (const [field, fieldData] of Object.entries(data)) {
            if (fieldData[`validator`] === 'text') {
                let error = null;
                if (fieldData[`isRequired`] && !fieldData[`value`]) {
                    error = 'This field is required.'
                    isValid = false
                }
                validatedData = {
                    ...validatedData,
                    [field]: {
                        ...fieldData as {},
                        error: error
                    }
                }
            }

            if (fieldData[`validator`] === 'number') {
                let error = null
                if (fieldData[`isRequired`] && isNaN(fieldData[`value`])) {
                    error = 'A valid number is required.'
                    isValid = false
                }
                validatedData = {
                    ...validatedData,
                    [field]: {
                        ...fieldData as {},
                        error: error
                    }
                }
            }

            if (fieldData[`validator`] === 'boolean') {
                let error = null
                if (fieldData[`isRequired`] && typeof fieldData[`value`] !== 'boolean') {
                    error = 'A valid number is required.'
                    isValid = false
                }
                validatedData = {
                    ...validatedData,
                    [field]: {
                        ...fieldData as {},
                        error: error
                    }
                }
            }

            if (fieldData[`validator`] === 'object') {
                let error = null
                if (
                    fieldData[`isRequired`] &&
                    (
                        !fieldData[`value`] ||
                        (!!fieldData[`value`] && Object.keys(fieldData[`value`]).length === 0 && fieldData[`value`].constructor === Object)
                    )
                ) {
                    error = 'This field is required.'
                    isValid = false
                }
                validatedData = {
                    ...validatedData,
                    [field]: {
                        ...fieldData as {},
                        error: error
                    }
                }
            }

            if (fieldData[`validator`] === 'array') {
                let error = null;
                if (!!fieldData[`value`] && fieldData[`value`].length === 0 && fieldData[`isRequired`]) {
                    error = 'This field is required.'
                    isValid = false
                }
                validatedData = {
                    ...validatedData,
                    [field]: {
                        ...fieldData as {},
                        error: error
                    }
                }
            }

            if (fieldData[`validator`] === 'email') {
                let error = null;
                if (fieldData[`isRequired`] && !fieldData[`value`]) {
                    error = 'This field is required.'
                    isValid = false
                }
                if (!!fieldData[`value`]) {
                    let lastAtPos = fieldData[`value`].lastIndexOf('@');
                    let lastDotPos = fieldData[`value`].lastIndexOf('.');
                    if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fieldData[`value`].indexOf('@@') == -1 && lastDotPos > 2 && (fieldData[`value`].length - lastDotPos) > 2)) {
                        isValid = false
                        error = "Email is not valid";
                    }
                }
                validatedData = {
                    ...validatedData,
                    [field]: {
                        ...fieldData as {},
                        error: error
                    }
                }
            }
        }
        resolve([validatedData, isValid])
    })
}

const formatUserFactories = (sbuList: any) => {
    let userFactories = [];
    for (let sbu of sbuList) {
        for (let plant of sbu.plants) {
            for (let factory of plant.factories) {
                userFactories.push({
                    sbuId: sbu.sbuId,
                    sbuCode: sbu.sbuCode,
                    sbuName: sbu.sbuName,
                    plantId: plant.id,
                    plantCode: plant.code,
                    plantName: plant.name,
                    factoryId: factory.id,
                    factoryCode: factory.code,
                    factoryName: factory.name,
                    isAssigned: factory.isAssigned,
                    isActive: factory.isActive,
                })
            }
        }
    }

    return userFactories;
}

export const formatDateTime = (rowDate): string => {
    let dateTimeString;
    const capturedDate = new Date(rowDate);
    let hours: string | number = capturedDate.getHours();
    let minutes: string | number = capturedDate.getMinutes();
    let seconds: string | number = capturedDate.getSeconds();

    hours = ('0' + hours).slice(-2);
    minutes = ('0' + minutes).slice(-2);
    seconds = ('0' + seconds).slice(-2);

    const year = capturedDate.getFullYear();
    const month = ('0' + (capturedDate.getMonth() + 1)).slice(-2);
    const date = ('0' + capturedDate.getDate()).slice(-2);

    dateTimeString = date + '-' + month + '-' + year + ' ' + hours + ':' + minutes + ':' + seconds;
    return dateTimeString;
}

export const groupArray = (list, key) => {
    return list.reduce((a, item,) => {
        (a[item[key]] = a[item[key]] || []).push(item)
        return a;
    }, {})
}

export const millisecondsToMinAndSec = (milliseconds: number): Array<string> => {
    const min = Math.floor(milliseconds / 60000);
    const sec = +((milliseconds % 60000) / 1000).toFixed(0);

    const minString = min.toLocaleString('en-us',
        {
            minimumIntegerDigits: 2,
            useGrouping: false
        });

    const secString = sec.toLocaleString('en-us',
        {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
    return ([minString, secString])
}

const isWebView = (activeUserAgent: string, webViewAgent: string) => {
    return activeUserAgent === webViewAgent
}


const formatCycleTimes = (cycleTime: number) => Math.round(cycleTime * 10) / 10

const padding = (num: number, size: number) =>
    new Array(size - num.toString().length).fill("0").join("") + num;

const getStudyNo = (factoryCode: string, studyName: string, studyNo: number) =>
    `${factoryCode.replace(/[^a-zA-Z0-9]/g, "")}-${STUDY_TYPE_ABBREVIATIONS[studyName.replace(/[ ]/g, "_").toUpperCase()]}-${padding(studyNo, 7)}`


export const utilFunctions = {
    validateFormData,
    formatUserFactories,
    formatDateTime,
    groupArray,
    millisecondsToMinAndSec,
    isWebView,
    formatCycleTimes,
    getStudyNo
};
